import { Environment } from './environment.interface';

export const environment: Environment = {
	name: 'demo',
	production: true,
	clientId: 'orchestrate_client',
	manageApiUrl: 'bs',
	acsConnectorApiUrl: '',
	acsConnectorAUApiUrl: '',
	developmentMode: false,
	clientHost: 'orchestratedemo.stage.commandcentral.com',
	singlePreprod: true,
	admin2ApiUrl: 'https://admin-api.pi.commandcentral.com/api/admin-v2',
	pendoEnabled: true,
	pendoJsFilePath: '/assets/pendo/pendo.js',
	admin2Url: 'https://admin2.pi.commandcentral.com',
	esriKey: 'AAPKa0f1e3a6e85d433b8bf7edccb142d440Fa8z4FKO5av7wLKn-T-hjb1ZOhdk68kC3JH_xdmmdtgpz_bLXGKDB1TL4RDFVKbD',
};

// Variables specifying the maximum depth of chained and failover nodes.
export const MAX_CHAIN_DEPTH = 2;
export const MAX_FAILOVER_DEPTH = 2;

// Going to make this a per env variable
export const ORCHESTRATE_SCOPE = 'connectx_orchestrate_demo';

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
